$(document).ready(function () {

    if (localStorage.getItem("day") == 1) {
        $('body').css('background', 'black');
        $('.site-mobile-menu').css('background', 'black');
        $('#modal_test').css('background', 'black');
    } else {
        $('body').css('background', '#024e9b');
        $('.site-mobile-menu').css('background', '#024e9b');
        $('#modal_test').css('background', '024e9b');
    }
    $("#sun").click(function () {
        $('body').css('background', '#024e9b');
        $('.site-mobile-menu').css('background', '#024e9b');
        $('#modal_test').css('background', '#024e9b');
        localStorage.setItem('day', 0);
    });
    $("#moon").click(function () {
        $('body').css('background', 'black');
        $('.site-mobile-menu').css('background', 'black');
        $('#modal_test').css('background', 'black');
        localStorage.setItem('day', 1);
    });

    if ($('#counter-red-my').length) {
        if (localStorage.getItem("games")) {
            $('#counter-red-my').text(JSON.parse(localStorage.getItem("games")).length)
            writeResult(JSON.parse(localStorage.getItem("games")));
        } else {
            $('#counter-red-my').text(0)
        }

    }

    if ($('#add-bookmark').length) {
        let url = $('span#remove-bookmark').get(0).getAttribute('data-id');

        let games = JSON.parse(localStorage.getItem("games"));
        if (games == null) {
            games = [];
        }
        if (urlExists(url, games)) {
            $('#remove-bookmark').removeClass('d-none');
            $('#add-bookmark').addClass('d-none');
        } else {
            $('#remove-bookmark').addClass('d-none');
            $('#add-bookmark').removeClass('d-none');
        }

    }

    $('#add-bookmark').on('click', function (event) {
        event.preventDefault();
        let games = JSON.parse(localStorage.getItem("games"));
        let img = $('.game-image').get(0).src.replace('preview', "300x300");
        let name = $('.game-image').get(0).alt;
        let button = $('span.game-bookmark').text();
        const game = {url: window.location.href, img: img, name: name, button: button};
        if (games == null) {
            games = [];
            games[0] = game;
            localStorage.setItem("games", JSON.stringify(games));
        } else {
            if (urlExists(window.location.href, games)) {

            } else {
                games.push(game);
                localStorage.setItem('games', JSON.stringify(games));
            }

        }
        let counter = JSON.parse(localStorage.getItem("games")).length;
        $('small#counter-red-my').text(counter);
        writeResult(games)
        $('#add-bookmark').addClass('d-none')
        $('#remove-bookmark').removeClass('d-none')
    });

    $("body").on("click", "span.game-bookmark", function (e) {
        e.preventDefault();
        deleteResult(this.getAttribute('data-id'), JSON.parse(localStorage.getItem("games")));
        let counter = JSON.parse(localStorage.getItem("games")).length;
        $('small#counter-red-my').text(counter);
        $('#remove-bookmark').addClass('d-none');
        $('#add-bookmark').removeClass('d-none')
    });

    let gameId = window.gameId;
    if (getCookie("vote_" + gameId)) {
        $(".rateit").css("pointer-events", "none");
    }
    $(".rateit").click(function () {
        newRate = $(this).rateit('value');
        if (!getCookie("vote_" + gameId)) {
            $(".rateit").css("pointer-events", "none");
            voteSubmit(gameId);
        }
    });
    $(".social__link").click(function () {
        shareCount(gameId);
    });

    $(".search").focus(function () {
        $(".search-box").addClass("border-searching");
        $(".search-icon").addClass("si-rotate");
    });
    $(".search").blur(function () {
        $(".search-box").removeClass("border-searching");
        $(".search-icon").removeClass("si-rotate");
    });
    $(".search").keyup(function () {
        if ($(this).val().length > 0) {
            $(".go-icon").addClass("go-in");
        } else {
            $(".go-icon").removeClass("go-in");
        }
    });
    $(".go-icon").click(function () {
        $(".search-form").submit();
    });
    // navigation click actions
    $('.scroll-link').on('click', function (event) {
        event.preventDefault();
        var sectionID = $(this).attr("data-id");
        scrollToID('#' + sectionID, 750);
    });
    // scroll to top action
    $('.scroll-top').on('click', function (event) {
        event.preventDefault();
        $('html, body').animate({scrollTop: 0}, 'slow');
    });
    // mobile nav toggle
    $('#nav-toggle').on('click', function (event) {
        event.preventDefault();
        $('#main-nav').toggleClass("open");
    });

    var siteMenuClone = function () {

        $('.js-clone-nav').each(function () {
            var $this = $(this);
            $this.clone().attr('class', 'site-nav-wrap').appendTo('.site-mobile-menu-body');
        });


        setTimeout(function () {

            var counter = 0;
            $('.site-mobile-menu .has-children').each(function () {
                var $this = $(this);

                $this.prepend('<span class="arrow-collapse collapsed">');

                $this.find('.arrow-collapse').attr({
                    'data-toggle': 'collapse',
                    'data-target': '#collapseItem' + counter,
                });

                $this.find('> ul').attr({
                    'class': 'collapse',
                    'id': 'collapseItem' + counter,
                });

                counter++;

            });

        }, 1000);

        $('body').on('click', '.arrow-collapse', function (e) {
            var $this = $(this);
            if ($this.closest('li').find('.collapse').hasClass('show')) {
                $this.removeClass('active');
            } else {
                $this.addClass('active');
            }
            e.preventDefault();

        });

        $(window).resize(function () {
            var $this = $(this),
                w = $this.width();

            if (w > 768) {
                if ($('body').hasClass('offcanvas-menu')) {
                    $('body').removeClass('offcanvas-menu');
                }
            }
        })

        $('body').on('click', '.js-menu-toggle', function (e) {
            var $this = $(this);
            e.preventDefault();

            if ($('body').hasClass('offcanvas-menu')) {
                $('body').removeClass('offcanvas-menu');
                $this.removeClass('active');
            } else {
                $('body').addClass('offcanvas-menu');
                $this.addClass('active');
            }
        })

        // click outisde offcanvas
        $(document).mouseup(function (e) {
            var container = $(".site-mobile-menu");
            if (!container.is(e.target) && container.has(e.target).length === 0) {
                if ($('body').hasClass('offcanvas-menu')) {
                    $('body').removeClass('offcanvas-menu');
                }
            }
        });
    };
    siteMenuClone();

    $(window).scroll(function () {
        if ($(this).scrollTop()) {
            $('#myBtn').fadeIn();
        } else {
            $('#myBtn').fadeOut();
        }
    });

    $("#myBtn").click(function () {
        $("html, body").animate({scrollTop: 0}, 1000);
    });
});

function getCookie(name) {
    name = name.toLowerCase();
    const parts = document.cookie.split(';');

    for (const part of parts) {
        const pair = part.split('=');
        const key = decodeURIComponent(pair[0].trim().toLowerCase());

        if (key === name) {
            return decodeURIComponent(pair[1]);
        }
    }

    return null;
}

function setCookie(name, value) {
    document.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value) + ';path=/';
}

function voteSubmit(gameId) {
    $.ajax({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        url: '/game-vote',
        dataType: 'json',
        type: 'post',
        data: {gameRate: newRate, gameId: gameId},
        success: function (response) {
            if (response.success === true) {
                setCookie("vote_" + gameId, true);
            }
        }
    });
}

function shareCount(gameId) {
    $.ajax({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        url: '/game-shares',
        dataType: 'json',
        type: 'post',
        data: {gameId: gameId},
    });
}

function urlExists($url, $arr) {
    return $arr.some(function (el) {
        return el.url === $url;
    });
}

function writeResult($arr) {
    var html = '';
    $arr.some(function (el) {
        html += '  <div class="col-4 col-md-2 col-lg-2 col-xl-2 item">\n' +
            '                        <a href="' + el.url + '">\n' +
            '                            <div class="image-wrap-1">\n' +
            '                                <img  alt="' + el.name + '" src="' + el.img + '" class="game-image img-fluid">\n' +
            '                            </div>\n' +
            '                        </a>\n' +
            '<span class="game-bookmark" data-id="' + el.url + '" style="color: red; text-align: center; display: block; cursor: pointer"><span class="icon-trash"></span></span>' +
            '                    </div>';
    });

    $("div.result-modal").html(html);

}

function deleteResult($url, $arr) {
    $arr.splice($arr.findIndex(v => v.url === $url), 1);
    writeResult($arr);
    localStorage.setItem('games', JSON.stringify($arr));
}
